module.exports = __webpack_public_path__ + "img/full3-min.f797f45a.png";